import { Box } from "@chakra-ui/react";
import ProtocolListPage from "./protocolListPage";

export default function ProtocolSettings() {
    return (
        <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
            <ProtocolListPage />
        </Box>
    );
} 